import { makeStyles, typographyStyles } from '@fluentui/react-components';

export const useEmptyStateActionStyles = makeStyles({
  actionContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  largeSurface: {},
  mediumSurface: {
    ...typographyStyles.caption1,
  },
  mediumMenu: {
    ...typographyStyles.caption2,
  },
  smallMenu: {
    ...typographyStyles.caption2,
  },
});
